import { apiGet } from '../support/helpers/ApiConnection.Helper';
import StateEntity from '../entities/State.Entity';

export default function getStates(abortSignal: AbortSignal): Promise<Array<StateEntity>> {    
    return apiGet<Array<StateEntity>>('/states',abortSignal);
}
